<div class="toolbar">
    <h1>RUBIFLIX</h1>
</div>